import { useTranslation } from '@nic/commons'
import { VariationRegistrantStepFormItems } from './VariationRagistrantStepFormItems'
import { Button, Form, FormInstance } from 'antd'
import {
  ContactDetailCard,
} from '../../../../../DataDisplay/RegistrantContactCards/Base/Card/ContactDetailCard/ContactDetailCard'
import { OrgRegCodeSelector } from './OrgRegCodeSelector'
import { IFieldError } from './utils'
import { Darwin, Domains, NicScope } from '@nic/nic-api/types'
import { useState } from 'react'
import { useRequestInfo } from '../../../../../Hooks/useRequestInfo'

interface VariationRegistrantStepFormProps {
  contact: Domains.Contact;
  anomalies: Darwin.Anomalies;
  contactUpdate?: Darwin.ContactUpdate;
  /** se vera abilita l'opzione per modificare o solo org o solo regcode **/
  enableSwitchOrgRegcode: boolean;
  form: FormInstance;
  initialValues?: {};
  errors?: IFieldError[];
  scope?: NicScope;
}


export function VariationRegistrantStepForm(
  props: VariationRegistrantStepFormProps
) {
  const { form } = props;
  const [switchValue, setSwitchValue] = useState<boolean>(
    props.enableSwitchOrgRegcode
  );
  const t = useTranslation();
  const { enableSwitchOrgRegcode } = props;
  const { request } = useRequestInfo();
  const showCopyButton = request?.status === 'registrarUpdated';
  const [updatedFields, setUpdatedFields] = useState<string[]>([]);

  const handleOnChange = (value: boolean) => {
    setSwitchValue(value);
    form.setFieldsValue({
      org: props.contact.org,
      registrant: { regcode: props.contact.registrant?.regcode },
    });
  };

  const handleCopyRegistrarData = () => {
    console.log("Starting handleCopyRegistrarData");
    const contactData = props.contactUpdate?.contactData;
    console.log("Contact Update Data:", contactData);

    if (!contactData) {
      console.warn("No contact update data found!");
      return;
    }

    const values: any = {};
    const newUpdatedFields: string[] = [];
    const currentValues = form.getFieldsValue();

    const checkAndSet = (field: string, newValue: any, nestedField?: string) => {
      if (newValue !== undefined && newValue !== null) {
        const currentValue = nestedField ? currentValues[field]?.[nestedField] : currentValues[field];
        // Compara valori (semplice comparazione per ora, dovrebbe essere migliorata con una deep equal per oggetti complessi)
        if (newValue !== currentValue) {
          if (nestedField) {
            if (!values[field]) values[field] = {};
            values[field][nestedField] = newValue;
            newUpdatedFields.push(nestedField); // Pushing nested field name for highlighting
          } else {
            values[field] = newValue;
            newUpdatedFields.push(field);
          }
        }
      }
    };

    // Map fields from contactData (IContact structure)
    checkAndSet('name', contactData.name);
    checkAndSet('org', contactData.org);

    // Address fields
    checkAndSet('streets', contactData.streets); // Comparazione array potrebbe richiedere attenzione se la semplice uguaglianza fallisce
    checkAndSet('city', contactData.city);
    checkAndSet('state', contactData.state);
    checkAndSet('postalCode', contactData.postalCode);
    checkAndSet('country', contactData.country);

    checkAndSet('voice', contactData.voice);
    checkAndSet('fax', contactData.fax);
    checkAndSet('email', contactData.email);
    checkAndSet('consentForPublish', contactData.consentForPublish);

    // Nested registrant fields
    if (contactData.registrant) {
      checkAndSet('registrant', contactData.registrant.regcode, 'regcode');
      checkAndSet('registrant', contactData.registrant.entityType, 'entityType');
      checkAndSet('registrant', contactData.registrant.nationality, 'nationality');
    }

    console.log("Mapped Values to set:", values);
    console.log("Current Form Values before set:", currentValues);
    form.setFieldsValue(values);
    setUpdatedFields(newUpdatedFields);
    console.log("Form Values after set:", form.getFieldsValue());
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
        <div style={{ marginLeft: 'auto' }}>
          {showCopyButton && (
            <Button onClick={handleCopyRegistrarData} type="primary" style={{ marginLeft: 10 }}>
              {t("Copia dati modificati dal Registrar")}
            </Button>
          )}
        </div>
        {props.enableSwitchOrgRegcode && (
          <OrgRegCodeSelector
            title={t('variationRegistrantStepView.orgRegcodeSelector.title')}
            description={t('variationRegistrantStepView.orgRegcodeSelector.description')}
            helperText={t('variationRegistrantStepView.orgRegcodeSelector.helperText')}
            orgLabel={t('label.org')}
            regcodeLabel={t('label.regcode')}
            onChange={handleOnChange}
          />
        )}
      </div>
      <ContactDetailCard
        style={{ width: "100%" }}
        cardTitle={t("variationRegistrantStepView.cardTitle")}
        contactTitle={t("variationRegistrantStepView.contactTitle")}
        contactSubTitle={t("variationRegistrantStepView.contactSubTitle")}
        color={"#ffd600"}
      >
        <Form
          form={props.form}
          name={"variation-registrant-step"}
          initialValues={props.contact}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 14 }}
        >
          <VariationRegistrantStepFormItems
            initialValues={props.contact}
            anomalies={props.anomalies}
            enableRegCode={enableSwitchOrgRegcode ? !switchValue : true}
            enableOrg={enableSwitchOrgRegcode ? switchValue : true}
            scope={props.scope}
            form={props.form}
            errors={props.errors}
            updatedFields={updatedFields}
          />
        </Form>
      </ContactDetailCard>
    </>
  );
}
